export default {
    MAX_WIDTH:1000,
    MAX_HEIGHT:1000,
    THUMBNAIL_MAX_WIDTH:400,
    THUMBNAIL_MAX_HEIGHT:400,
    // HUMAN_FACE_LANDMARKS_ENDPOINT:"http://localhost:5001/petswitch-d2764/us-central1/getFaceLandmarks",
    // PET_FACE_LANDMARKS_ENDPOINT:"http://localhost:5001/petswitch-d2764/us-central1/getPetFaceLandmarks"
    HUMAN_FACE_LANDMARKS_ENDPOINT:"https://us-central1-petswitch-d2764.cloudfunctions.net/getFaceLandmarks",
    PET_FACE_LANDMARKS_ENDPOINT:"https://us-central1-petswitch-d2764.cloudfunctions.net//getPetFaceLandmarks"
}